<template>
  <div class="trainingDetail">
    <div id="trainingDetail">

      <div ref="videobox" id="mui-player"></div>

      <div class="top-content">
        <div class="van-card">
        </div>
        <div class="remark">
          <div class="title">{{ data.name }}</div>
          <div class="content">{{ data.remark }}</div>
          <div class="content-tag">
            <van-tag round>{{ data.studyCount }}人已学习</van-tag>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getNum } from '@api/activity'
import { getDetail, playRecord } from '@api/injury'
import 'mui-player/dist/mui-player.min.css'
import MuiPlayer from 'mui-player'

export default {
  name: 'trainingDetail',
  data () {
    return {
      time: false,
      autoplay: true,
      state: false,
      currTime: null,
      maxTime: 0,
      tipShow: false,
      data: {},
      videoUrl: '',
      projectId: undefined,
      courseId: undefined,
      isFirstPlay: true,
      backType: true,
    }
  },
  created () {
    this.projectId = this.$route.query.projectId
    this.courseId = this.$route.query.courseId
    this.contentDetail()
  },
  watch: {},
  mounted () {
    // 延迟1秒
    setTimeout(() => {
      // 监听视频是否播放完毕
      if (!this.state) {
        document.querySelector('video').loop = false // 不设置视频循环播放;
        document.querySelector('video').addEventListener('ended', () => { //该视频播放是否已结束
          this.state = true
          this.videoEnd()
        }, false)
      }
      // this.cannotSpeed()
    }, 500)
  },

  methods: {

    // 视频快进
    cannotSpeed () {
      let sym
      let video = document.querySelector('video') // 获取到video
      let that = this
      setInterval(function () {
        let time = video.currentTime
        if (time - sym > 1) {
          that.playRecord(video.currentTime / video.duration * 100, video.currentTime)
        }
        sym = video.currentTime
      }, 500)
    },

    // 视频播放完调用
    videoEnd () {
      let video = document.querySelector('video') // 获取到video
      this.$bridge.callHandler('backRefreshMark', response => {
        console.log('response:', response)
      })
      this.playRecord(100, video.duration)
    },

    // 初始化视频
    updateVideo () {
      let currentTime = 0
      let that = this
      // 初始化 MuiPlayer 插件，MuiPlayer 方法传递一个对象，该对象包括所有插件的配置
      var mp = new MuiPlayer({
        container: '#mui-player',
        src: this.videoUrl,
        preload: 'auto',
        autoplay: true,
        poster: this.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast',
        videoAttribute: [
          {
            attrKey: 'webkit-playsinline',
            attrValue: false
          }, {
            attrKey: 'playsinline',
            attrValue: false
          }
        ]
      })

      // 视频初始化完成
      mp.on('ready', function (event) {
        that.getNum()
        let video = document.querySelector('video')
        video.addEventListener('play', function () { //播放开始执行的函数
          if (currentTime > 0) {
            setTimeout(() => {
              video.currentTime = currentTime
              currentTime = 0
            }, 1000)
          }
          if (that.isFirstPlay) {
            currentTime = video.currentTime
            if (currentTime === 0) {
              setTimeout(() => {
                video.currentTime = that.currentDuration
              }, 1000)
            } else {
              video.load()
              video.play()
            }
            that.isFirstPlay = false
          }
        })

        //使用事件监听方式捕捉事件
        let state = true
        video.addEventListener('timeupdate', function () {
          let timeDisplay
          //用秒数来显示当前播放进度
          timeDisplay = Math.floor(video.currentTime)
          //当视频播放到 10s的时候做处理
          if (timeDisplay > 1 && timeDisplay % 10 == 0) {
            if (state) {
              state = false
              // console.log('获取视频时长', video.duration) //获取视频时长
              // console.log('获取视频当前播放时间', video.currentTime) //获取视频当前播放时间
              that.playRecord(video.currentTime / video.duration * 100, video.currentTime)
              setTimeout(() => {
                //请求成功后在返回的状态里面加上下面这句话
                state = true
              }, 2000)
            }

            if (that.backType) {
              that.backType = false
              that.$bridge.callHandler('backRefreshMark', response => {
                console.log('response:', response)
              })
            }
          }
        }, false)

      })

    },

    // 记录观看时间
    playRecord (currentRate, currentDuration) {

      playRecord({
        projectId: this.projectId,
        courseId: this.courseId,
        currentRate: Math.round(currentRate),
        currentDuration: Math.round(currentDuration),
        recordId: this.recordId
      }).then(res => {
        if (res.data.code === 200) {
          if (!this.recordId) {
            this.recordId = res.data.data
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 获取详情
    contentDetail () {
      getDetail({
        projectId: this.projectId,
        courseId: this.courseId
      }).then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
          this.videoUrl = res.data.data.videoUrl
          this.currentRate = res.data.data.currentRate
          if (this.currentRate === 100) {
            this.currentDuration = 0
          } else {
            this.currentDuration = res.data.data.currentDuration
          }
          this.updateVideo()
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 参与金币活动
    getNum () {
      getNum().then(res => {
        if (res.data.code === 200) {
          if (res.data.data) {
            setTimeout(() => {
              const data = {
                title: '学安全知识 送万元金币',
                url: `${process.env.VUE_APP_BASE_HOST}/activity/cashVideo`
              }
              this.$bridge.callHandler('newPage', data, response => {
                console.log('response:', response)
              })
            }, 1000)
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/mixin";

#mui-player {
  height: 200px !important;

  //noinspection CssInvalidPseudoSelector
  ::v-deep #back-button {
    display: none !important;
  }
}

.trainingDetail {
  /*height: 100%;*/
  min-height: 100%;
  padding-bottom: 80px;

  .btn-div {
    text-align: center;
    position: fixed;
    bottom: 20px;
    width: 100%;
    z-index: 99;
  }

  .top-content {

    .remark {
      border-bottom: 0.5px solid white;
      padding: 0 10px 10px 10px;
      background-color: white;

      .title {
        @include add_size($font_size_16);
        font-weight: bold;
        padding: 10px 0;
      }

      .content {
        @include add_size($font_size_14);
      }

      .content-tag {
        padding-top: 10px;
        font-size: 1px;

        .van-tag {
          background-color: #EEEEEEFF;
          color: #999999FF;
          @include add_size($font_size_12);
          padding: 4px 12px;
          margin: 0 10px 10px 0;
        }
      }
    }

    .van-card {
      background-color: white;
      padding: 10px 10px 0 10px;

      .type-button {
        height: 35px;
        margin: 0 10px 10px 0;
        color: #333333FF;
        @include add_size($font_size_15);
        padding: 5px 12px;
        background-color: #EFF5FEFF;
        border-radius: 5px;
      }

      .active {
        color: #FFFFFFFF;
        background-color: #096CEFFF;
      }
    }

    .van-card__content {
      min-height: 0;
    }

    .van-card__thumb {
      height: 80px;
      width: 80px;
    }

    .card-title {
      font-weight: bold;
      @include add_size($font_size_18);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; //控制行数
      overflow: hidden;
    }

    .card-introduce {
      color: #999999;
      @include add_size($font_size_16);
      padding: 2px 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; //控制行数
      overflow: hidden;
    }

    .content-ft {
      @include add_size($font_size_16);
    }
  }

  .list-content {
    font-size: 1px;
    padding-top: 4px;

    .van-tag {
      background-color: #EEEEEEFF;
      color: #999999FF;
      @include add_size($font_size_14);
      padding: 6px 24px;
      margin-bottom: 10px;
      margin-right: 10px;
    }

    .active {
      background-color: #37A1FFFF;
      color: #FFFFFFFF;
    }
  }
}
</style>
